





















import { Component } from 'nuxt-property-decorator'
import { LayoutComponentVue } from '@/base'
import { appStore } from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'

@Component({
  middleware: ['authenticated', 'redirect']
})
export default class LoginLayout extends LayoutComponentVue {
  loading = false

  isConnected = false

  get appClass(): object {
    return {
      'font-family-sans-serif': appStore.fontFamilyIsSansSerif,
      'font-family-serif': !appStore.fontFamilyIsSansSerif
    }
  }

  created() {
    this.$eventBus.on(PAGE_LOADING_START, this.onPageLoadingStart)
    this.$eventBus.on(PAGE_LOADING_END, this.onPageLoadingEnd)

    const useAuthKey: string = process.env.USE_AUTH_KEY || '0'
    if (useAuthKey === '0') {
      this.isConnected = true
      this.$webSocket.connect()
    } else {
      this.onPageLoadingStart()
      this.$webSocket.connect(() => {
        if (!this.$webSocket.isOpen()) {
          this.onPageLoadingEnd()
        } else {
          setTimeout(() => {
            if (this.$webSocket.authKey !== '') {
              this.isConnected = true
            }
            this.onPageLoadingEnd()
          }, 1000)
        }
      })
    }
  }

  destroyed() {
    this.debug('destroyed()')
  }

  onPageLoadingStart() {
    this.loading = true
  }

  onPageLoadingEnd() {
    this.loading = false
  }
}
